/** @module SiteAdmin/HomePage/TableToolbar */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/html",
	"csi/prefs",
	"csi/view/Toolbar",
	"dojo/text!./TableToolbar.html",

	"dijit/form/Button",
	"dijit/form/ToggleButton"
], function(declare,lang,html,csiPrefs,Toolbar,template) {

	return declare(Toolbar, {
		baseClass: "csi-homepage-table-toolbar",
		templateString: template,

		editChartNode: null,
		toggleChartNode: null,
		toggleTableNode: null,
		toggleButtonNodes: null,

		/** @property {boolean} allowToggle - set to true if user has access to change custom view toggle states */
		allowToggle: false,

		/** @property {csi/view/Widget} view */
		view: null,

		/**
		 * Extension point for toggling display of chart on/off.
		 * @param {boolean} value
		 */
		onToggleChart: function(value) {},

		/**
		 * Extension point for toggling display of table on/off.
		 * @param {boolean} value
		 */
		onToggleTable: function(value) {},

		/**
		 * Initialize toolbar.
		 */
		setView: function() {
			var ret = this.inherited(arguments);
			var view = this.view;
			var updateCallback = lang.hitch(this, this._updateButtonStates);

			// initialize chart/table toggle buttons
			this._updateButtonStates();

			// listen for changes to view to update visibility and disabled status of widgets.
			view.watch("chartHideTable", updateCallback);
			view.watch("chartHide", updateCallback);
			view.watch("chartSettings", updateCallback);
			view.watch("disabled", updateCallback);

			return ret;
		},

		/**
		 * Event handler for editing chart.
		 */
		_onEditChart: function() {
			this.view.getPlugin("charts").editFirstChart();
		},

		/**
		 * Event handler for toggling display of chart on/off.
		 * @param {boolean} value
		 */
		_onToggleChart: function(value) {
			this.onToggleChart(value);
		},

		/**
		 * Event handler for toggling display of table on/off.
		 * @param {boolean} value
		 */
		_onToggleTable: function(value) {
			this.onToggleTable(value);
		},

		_setAllowToggleAttr: {node: "toggleButtonNodes", type: "toggleClass"},

		/**
		 * Update button states based on current view settings.
		 */
		_updateButtonStates: function() {
			var view = this.view;
			if (!view) {
				return;
			}

			var limited = !!view.getQueryLimitIfReached();
			var chartsPlugin = view.getPlugin("charts");
			var bChart = view.hasChart();
			var bCanChart = bChart;
			var hideChart = view.get("chartHide");
			var hideTable = view.get("chartHideTable");

			// only allow creating a chart if there are attributes in the view to chart (or there already is a chart)
			if (chartsPlugin && !bCanChart) {
				bCanChart = chartsPlugin.hasSelectOption();
			}
			
			// only allow toggling table off if there is a chart
			this.toggleChartNode.set("disabled", limited || !bCanChart);
			this.toggleTableNode.set("disabled", limited || (!bChart && !hideTable));

			// toggle buttons directly track corresponding view settings
			this.toggleChartNode.set("checked", bChart && !hideChart);
			this.toggleTableNode.set("checked", !hideTable);

			// only enable editing chart if there is one displayed
			html.setVisible(this.editChartNode, bChart && !hideChart);
		}
	});
});
